import {useConfigContext} from 'src/components/widget/hooks/useConfigContext';

export const DafIcon = () => {
	const {primaryColor} = useConfigContext();
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
				stroke={primaryColor}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M13 16v-.667c0-.353-.21-.692-.586-.943C12.04 14.14 11.53 14 11 14H7c-.53 0-1.04.14-1.414.39-.375.25-.586.59-.586.943V16M9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
				stroke={primaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
